import * as actionTypes from './actionTypes';
import { EnabledAccount } from './types';

/*------------------------------------------------------------------------------------------------*/
/* EnabledAccounts Fetch Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const fetchEnabledAccountsRequest = () => ({
  type: actionTypes.FETCH_ENABLED_ACCOUNTS_REQUEST,
});

export const fetchEnabledAccountsError = (error: string) => ({
  type: actionTypes.FETCH_ENABLED_ACCOUNTS_ERROR,
  error,
});

export const fetchEnabledAccountsResponse = (response: EnabledAccount[]) => ({
  type: actionTypes.FETCH_ENABLED_ACCOUNTS_RESPONSE,
  response,
});
